/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_App_TitleInputs */

const en_error_app_title = /** @type {(inputs: Error_App_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App crashed`)
};

const pl_error_app_title = /** @type {(inputs: Error_App_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikacja przestała działać`)
};

/**
* | output |
* | --- |
* | "App crashed" |
*
* @param {Error_App_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const error_app_title = /** @type {((inputs?: Error_App_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_App_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_error_app_title(inputs)
	return en_error_app_title(inputs)
});